import { Component, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '@ntconsult/aluma-react';
import i18n from '../../config/i18n';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const t = (key: string, fallback: string) => {
        try {
          const result = i18n.t(key);
          return result === key ? fallback : result;
        } catch {
          return fallback;
        }
      };

      return (
        <div className="flex items-center justify-center min-h-screen bg-surface-raised">
          <div className="text-center max-w-md px-4">
            <AlertTriangle className="w-16 h-16 text-danger mx-auto mb-4" />
            <h1 className="text-2xl font-semibold text-foreground mb-2">
              {t('common:error.title', 'Algo deu errado')}
            </h1>
            <p className="text-foreground-muted mb-6">
              {t('common:error.message', 'Ocorreu um erro inesperado. Tente recarregar a pagina.')}
            </p>
            <Button onClick={this.handleReload}>
              {t('common:error.reload', 'Recarregar Pagina')}
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
